import { render, staticRenderFns } from "./NewIndex.vue?vue&type=template&id=6fe32cd2&scoped=true&"
import script from "./NewIndex.vue?vue&type=script&lang=js&"
export * from "./NewIndex.vue?vue&type=script&lang=js&"
import style0 from "./NewIndex.vue?vue&type=style&index=0&id=6fe32cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe32cd2",
  null
  
)

export default component.exports